module.exports = __webpack_public_path__ + "img/vue-kanban.0743ede0.png";